export default __webpack_public_path__ + "static/media/element_spec_40.10a5fc7e.webp";